module.exports = __webpack_public_path__ + "img/mic.7e3369a1.svg";